import * as actionType from "../constants";
import * as commonData from "../Common";
import { getBoardHistory } from "./update-single-row";

export const addMonitoring =
  (inputs, any = null) =>
  async (dispatch) => {
    //dispatch({ type: actionType.MONITOR_ADDING });
    const api = commonData.commonData().apiUrl;
    try {
      const resp = await fetch(`${api}tattle/add-monitoring`, {
        method: "post",
        body: JSON.stringify(inputs),
      });
      const data = await resp.json();
      if (data.code === 200) {
        if (any == "status") {
          return data;
        }
        dispatch({ type: actionType.ADDING_MONITOR, payload: data.data });
        setTimeout(() => {
          dispatch(
            getBoardHistory(
              {
                attribute_set_key: inputs.attribute_set_key,
                customer_tattle_uuid: inputs.customer_tattle_uuid,
                app_token: inputs.app_token,
              },
              any
            )
          );
        });
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
